module.exports = __webpack_public_path__ + "img/myAccountIcon.ed3c8356.svg";